import { render, staticRenderFns } from "./IconBetaOrders.vue?vue&type=template&id=2203b304&"
import script from "./IconBetaOrders.vue?vue&type=script&lang=ts&"
export * from "./IconBetaOrders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports